// @ts-nocheck
export default class GeocoderControl {
  constructor() {
    this._input = document.createElement('input');

    this._input.type = 'text';

    this._input.style.width = '250px';
    this._input.style.padding = '0 12px';
    this._input.style.margin = '16px 0 0 16px';
    this._input.style.height = '32px';
    this._input.style.fontSize = '14px';
    this._input.style.outline = 'none';
    this._input.style.border = '1px solid transparent';
    this._input.style.boxShadow = '0 2px 6px rgba(0, 0, 0, .3)';
    this._input.style.borderRadius = '2px';
    this._input.style.transition = 'all 0.2s ease-in-out';

    this._input.placeholder = 'Search places';
  }

  get element() {
    return this._input;
  }
}
